import { getAssertion } from "@/lib/passkey";
import { api, idem, unwrap } from "./client";
import { ApiError } from "./errors";

/** Retry a security change only after the user verifies the exact action. */
export async function withAccountConfirmation<T>(subject: string, action: (headers?: Record<string, string>) => Promise<T>): Promise<T> {
  try {
    return await action();
  } catch (error) {
    if (!(error instanceof ApiError) || error.code !== "passkey_verification_failed") throw error;
    const challenge = await unwrap(api.POST("/v1/auth/step-up/begin", {
      params: { header: idem() }, body: { purpose: "manage_account", subject_id: subject },
    }));
    const credential = await getAssertion(challenge.public_key_request);
    const assertion = btoa(JSON.stringify({ challenge_id: challenge.challenge_id, credential }))
      .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    return action({ "Guv-Step-Up-Assertion": assertion });
  }
}
